// extracted by mini-css-extract-plugin
module.exports = {"content_wrapper":"content_wrapper__ToEV5WjuS62Vh","caption":"caption__Jkl4B2QHtxxHe"};